import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VMain, {
    style: _vm.backgroundStyle
  }, [_c('div', {
    class: _vm.fillHeight,
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('error-boundary', [_c(VFadeTransition, {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('router-view', {
    ref: "routerview"
  })], 1)], 1)], 1)]), _vm.footer ? _c('core-footer', {
    attrs: {
      "footerData": _vm.footerData
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };